import { render } from "./YourEthnicity.vue?vue&type=template&id=e35ee3ca&scoped=true"
import script from "./YourEthnicity.vue?vue&type=script&lang=js"
export * from "./YourEthnicity.vue?vue&type=script&lang=js"

import "./YourEthnicity.vue?vue&type=style&index=0&id=e35ee3ca&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e35ee3ca"]])

export default __exports__